import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { CloudinaryUrlModule } from '../cloudinary-url/cloudinary-url.module';
import { UiModule } from '../ui/ui.module';
import { MeetingComponent } from './meeting.component';
import { MeetingService } from './meeting.service';

@NgModule({
  declarations: [MeetingComponent],
  imports: [CommonModule, UiModule, CloudinaryUrlModule, TranslateModule],
  providers: [MeetingService],
  exports: [MeetingComponent],
})
export class MeetingModule {
  constructor(
    private meetingService: MeetingService,
    @Optional() @SkipSelf() parentModule?: MeetingModule
  ) {
    if (parentModule) {
      throw new Error('MeetingModule is already loaded. Import it in the AppModule only');
    }
    this.meetingService.init();
  }
}
